import React from "react";
import { Typography, Box } from "@mui/material";
import MarkupMAIQ from 'app/components/ReusableUIComponents/HighLevelComponents/MarkupMAIQ';

interface ExecutiveSummaryViewProps {
    title: string;
    text: string;
    isStreaming?: boolean;
}

const ExecutiveSummaryViewComponent = ({ title, text, isStreaming = false }: ExecutiveSummaryViewProps) => {
    const showSkeleton = !text || text.trim().length === 0;

    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>
            <Box
                sx={{
                    backgroundColor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: '0 2px 8px rgba(65, 65, 65, 0.243)',
                    p: 3,
                }}
            >
                {showSkeleton ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                        }}
                    >
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                backgroundColor: (theme) => 
                                    theme.palette.mode === 'dark' 
                                        ? theme.palette.primary.main 
                                        : theme.palette.primary.light,
                                animation: 'chatGptThinking 1.4s ease-in-out infinite',
                                '@keyframes chatGptThinking': {
                                    '0%': {
                                        transform: 'scale(0.8)',
                                        opacity: 0.5,
                                    },
                                    '50%': {
                                        transform: 'scale(1.2)',
                                        opacity: 1,
                                    },
                                    '100%': {
                                        transform: 'scale(0.8)',
                                        opacity: 0.5,
                                    },
                                },
                            }}
                        />
                    </Box>
                ) : (
                    <Box
                        sx={{ 
                            wordBreak: 'break-word',
                            lineHeight: 1.6,
                            fontSize: '18px'
                        }}
                    >
                        <MarkupMAIQ content={text} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

ExecutiveSummaryViewComponent.displayName = 'ExecutiveSummaryView';

export const ExecutiveSummaryView = React.memo(ExecutiveSummaryViewComponent);